import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ecommerce-user-inicio',
  templateUrl: './ecommerce-user-inicio.component.html',
  styleUrls: ['./ecommerce-user-inicio.component.css']
})
export class EcommerceUserInicioComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
